export enum CabinContentsInsuranceType {
  CABIN_CONTENTS_STANDARD = "cabinContentsStandard",
  CABIN_CONTENTS_SUPER = "cabinContentsSuper",
}

export enum NotSuperReasonCabinContents {
  HAS_RENTAL = "hasRental",
}
